<template>
  <div>
    <div>
      <content-block
        :content="footerCopyright.content" />
    </div>
  </div>
</template>

<script>
import ContentBlock from '~/components/ContentBlock.vue';

export default {
  components: {
    ContentBlock,
  },
  props: {
    footerCopyright: {
      type: [String, Object],
      default: '',
    },
  },
};
</script>
